<template>
  <div class="MaritalStatusField">
    <div class="label">
      <span class="required">*</span>{{ label }}
    </div>
    <div class="value" @click="show = true">
      <div v-if="MaritalStatusField">{{ MaritalStatusField }}</div>
      <div v-else style="color: rgba(51,51,51,0.4);">请选择</div>
      <img class="oride-icon" src="@/assets/style/oride-icon.png" alt="">
    </div>
    <van-action-sheet v-model="show" :actions="actions" @select="onSelect" />
  </div>
</template>

<script>
export default {
  name: "MaritalStatusField",
  components: {},
  props: {
    label: {
      type: String,
      default: "",
    },
    value: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      MaritalStatusField: "",
      show: false,
      MaritalStatusValue: "",
      actions: [
        {
          name: "未婚",
          value: "1",
        },
        {
          name: "已婚",
          value: "2",
        },
      ],
    };
  },
  async mounted() {},
  methods: {
    onSelect(item) {
      this.MaritalStatusField = item.name;
      this.$emit("input", item.value);
      this.show = false;
    },
  },
  watch: {
    value(newVal) {
      this.MaritalStatusValue = newVal;
    },
  },
};
</script>

<style scoped lang="scss">
.MaritalStatusField {
  display: flex;
  align-items: center;
  padding: 12px 0px;
}
.label {
  font-size: 14px;
  color: #333333;
  width: 80px;
  .required{
    color: #FF0000;
  }
}
.value {
  flex: 1;
  display: flex;
  align-items: center;
  height: 33px;
  border-radius: 17px;
  padding: 0px 16px;
  justify-content: space-between;
  font-size: 14px;
  color: #333333;
  background: #F8F8F8;
  .oride-icon {
    height: 20px;
    margin-left: 10px;
  }
}
</style>
